import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://lhgsudoowjefmmtpdwtj.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxoZ3N1ZG9vd2plZm1tdHBkd3RqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTIxMzcxMzMsImV4cCI6MjA2NzcxMzEzM30.9yrORLJgnnd37f_rKc9NAUZyPxuGUBRxoBJLwblqXtk';

export const supabase = createClient(
  supabaseUrl,
  supabaseAnonKey,
  {
    realtime: {
      params: {
        eventsPerSecond: 10
      }
    },
    db: {
      schema: 'public'
    },
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
      flowType: 'pkce'
    }
  }
);
